import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const Thresholds = ({ thresholds }) => (
  <>
    <h5>Patient Thresholds</h5>
    <Table
      borderless
      border="0"
      cellSpacing="0"
      cellPadding="0"
      className="thresholds-table"
    >
      <thead>
        <tr>
          <th colSpan="3">
            <div className="pagination-container">
              <h5>Reading Type</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Systolic</td>
          <td>
            <span>Max Critical: {thresholds?.maxCriticalSystolic}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskSystolic}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalSystolic}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskSystolic}
            </span>
          </td>
        </tr>
        <tr>
          <td>Diastolic</td>
          <td>
            <span>Max Critical: {thresholds?.maxCriticalDiastolic}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskDiastolic}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalDiastolic}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskDiastolic}
            </span>
          </td>
        </tr>
        <tr>
          <td>Pulse</td>
          <td>
            <span>Max Critical: {thresholds?.maxCriticalPulse}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskPulse}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalPulse}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskPulse}
            </span>
          </td>
        </tr>

        <tr>
          <td>Sp02</td>
          <td>
            <span>Max Critical: {thresholds?.criticalBloodoxygen}</span>
          </td>
          <td>
            <span className="subtext">
              Max At Risk: {thresholds?.riskBloodoxygen}
            </span>
          </td>
        </tr>
        <tr>
          <td>Glucose</td>
          <td>
            <span>Max Critical: {thresholds?.maxCriticalGlucose}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskGlucose}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalGlucose}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskGlucose}
            </span>
          </td>
        </tr>
        <tr>
          <td>Weight</td>
          <td>
            <span>Baseline: {thresholds?.baseLineWeight}</span>
            <span>Max Critical: {thresholds?.maxCriticalWeight}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskWeight}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalWeight}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskWeight}
            </span>
          </td>
        </tr>
        <tr>
          <td>Resting Pulse</td>
          <td>
            <span>Max Critical: {thresholds?.maxCriticalSleepPulse}</span>
            <span className="subtext">
              Max At Risk: {thresholds?.maxRiskSleepPulse}
            </span>
          </td>
          <td>
            <span>Min Critical: {thresholds?.minCriticalSleepPulse}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskSleepPulse}
            </span>
          </td>
        </tr>
        <tr>
          <td>PEF</td>
          <td />
          <td>
            <span>Min Critical: {thresholds?.minCriticalPef}</span>
            <span className="subtext">
              Min At Risk: {thresholds?.minRiskPef}
            </span>
          </td>
        </tr>
        <tr>
          <td>FEV1</td>
          <td />
          <td>
            <span>Min Critical: {thresholds?.minCriticalFev1}</span>
          </td>
        </tr>
      </tbody>
    </Table>
  </>
);

Thresholds.propTypes = {
  thresholds: PropTypes.shape().isRequired,
};

export default Thresholds;
